import { render } from "./ItemTicket.vue?vue&type=template&id=b1a4cbfc&scoped=true"
import script from "./ItemTicket.vue?vue&type=script&lang=js"
export * from "./ItemTicket.vue?vue&type=script&lang=js"

import "./ItemTicket.vue?vue&type=style&index=0&id=b1a4cbfc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1a4cbfc"]])

export default __exports__